<template>
  <v-dialog max-width="650" v-model="dialog.shows.showApp">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="sendForm">
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col class="mb-0 py-0" cols="12" sm="6"
                     v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL']) && checkAction()">
                <v-autocomplete
                  :error="!_.isNull(apiFormErrors['user'])"
                  :error-messages="!_.isEmpty(errorsUser)?errorsUser:apiFormErrors['user']"
                  :items="itemsUsers"
                  :label="$vuetify.lang.t('$vuetify.application.cols.user.title')"
                  :loading="isLoading"
                  :search-input.sync="search"
                  @blur="$v.form.user.$touch()"
                  @input="$v.form.user.$touch()"
                  autocomplete="off"
                  hide-no-data
                  hide-selected
                  prepend-icon="mdi-account-multiple-outline"
                  v-model="form.user"
                ></v-autocomplete>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['shortName'])"
                  :error-messages="!_.isEmpty(errorsShortName)?errorsShortName:apiFormErrors['shortName']"
                  :label="$vuetify.lang.t('$vuetify.application.cols.shortName.title')"
                  @blur="$v.form.shortName.$touch()"
                  @input="$v.form.shortName.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-code-string"
                  v-model="form.shortName"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['name'])"
                  :error-messages="!_.isEmpty(errorsName)?errorsName:apiFormErrors['name']"
                  :label="$vuetify.lang.t('$vuetify.application.cols.name.title')"
                  @blur="$v.form.name.$touch()"
                  @input="$v.form.name.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-account-card-details-outline"
                  v-model="form.name"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12"
                     sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['email'])"
                  :error-messages="!_.isEmpty(errorsEmail)?errorsEmail:apiFormErrors['email']"
                  :label="$vuetify.lang.t('$vuetify.application.cols.email.title')"
                  @blur="$v.form.email.$touch()"
                  @input="$v.form.email.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-at"
                  type="email"
                  v-model="form.email"
                ></v-text-field>
              </v-col>
              <v-col :sm="checkAction() ? 12 : 6" class="mb-0 py-0" cols="12">
                <v-textarea
                  :label="$vuetify.lang.t('$vuetify.application.cols.description.title')"
                  auto-grow
                  prepend-icon="mdi-note-text"
                  rows="1"
                  v-model="form.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.shows.showApp = false" text>{{ $vuetify.lang.t('$vuetify.btn.close') }}</v-btn>
          <v-btn
            :loading="loadingBtn"
            color="secondary"
            text
            type="submit"
          >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import FormMixin from '../../mixins/Common/Forms';
  import {required, maxLength, minLength, email, requiredIf} from "vuelidate/lib/validators";
  import {isUniqueApplicationName} from "../../helpers/Validators";
  import URLPath from "../../helpers/URL";

  export default {
    mixins: [FormMixin],
    props: {
      dialog: {
        type: Object,
        default: function () {
          return {
            title: "$vuetify.application.new.title",
            shows: {
              showApp: false
            },
            saveBtnTitle: "$vuetify.btn.save",
            action: "create"
          };
        }
      },
      form: {
        type: Object,
        default: function () {
          return {
            name: null,
            shortName: null,
            description: null,
            user: null,
            email: null
          };
        }
      }
    },
    watch: {
      search(val) {
        if (!val)
          return;
        if (val.length < 3)
          return;
        this.getUsers(val);
      }
    },
    validations() {
      let validators = {
        form: {
          name: {required, maxLength: maxLength(40), minLength: minLength(3), isUnique: isUniqueApplicationName},
          shortName: {required, maxLength: maxLength(11), minLength: minLength(3)},
          email: {email},
          user: {
            required: requiredIf((component) => {
              let attribut = Object.keys(component).length;
              if (attribut === 5) return false;
              return !(component["user"]);
            })
          }
        }
      };
      return validators;
    },
    data: () => ({
      itemsUsers: [],
      loadingBtn: false,
      search: null,
      isLoading: false
    }),
    methods: {
      getUsers(val) {
        let query = "u_username::iLike::%" + val + "%";
        let params = {
          url: URLPath.USER.LIST,
          params: {
            _search: query
          }
        };
        this.itemsUsers = [];
        let self = this;
        this.isLoading = true;
        this.$store
          .dispatch("request", params)
          .then((r) => {
            let self = this;
            r.data.items.forEach(user => {
              self.itemsUsers.push({
                text: user.username,
                value: user.id
              });
            });
            self.isLoading = false;
          }).catch(() => {
          self.isLoading = false;
        })
      },
      sendForm() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let self = this;
          this.loadingBtn = true;
          this.save(this.getFormParam())
            .then(() => {
              this.$emit("getItems");
              self.$store.dispatch("setNotification", {
                status: true,
                message: self.$vuetify.lang.t("$vuetify.success_form")
              });
              self.dialog.shows.showApp = false;
              if (this.dialog.action === "create") this.resetForm();
            }).catch(() => {
            this.$forceUpdate();
          }).finally(() => {
            self.loadingBtn = false;
          })
        }
      },
      getFormParam() {
        let params = {};
        switch (this.dialog.action) {
          case "user":
            params["url"] = URLPath.USER.APPLICATION.URI.replace(
              "{USER_ID}",
              this.form.user
            );
            params["data"] = this._.omit(this.form, ["id", "user", "apiKey", "secret", "notificationActive", "active", "oldName"]);
            params["method"] = URLPath.USER.APPLICATION.METHOD;
            break;
          case "edit":
            params["url"] = URLPath.APPLICATION.EDIT.URI.replace(
              "{APPLICATION_ID}",
              this.form["id"]
            );
            params["data"] = this._.omit(this.form, ["id", "user", "apiKey", "secret", "notificationActive", "active", "oldName"]);
            params["method"] = URLPath.APPLICATION.EDIT.METHOD;
            break;
          case "create":
            if (this.form.user) {
              params["url"] = URLPath.USER.APPLICATION.URI.replace(
                "{USER_ID}",
                this.form.user
              );
              params["data"] = this._.omit(this.form, ["id", "user", "apiKey", "secret", "notificationActive", "active", "oldName"]);
              params["method"] = URLPath.USER.APPLICATION.METHOD;
            } else {
              params["url"] = URLPath.APPLICATION.CREATE.URI;
              params["method"] = URLPath.APPLICATION.CREATE.METHOD;
            }
            params["data"] = this._.omit(this.form, ["id", "user", "apiKey", "secret", "notificationActive", "active", "oldName"]);
            break;
        }
        return params;
      },
      setForm(item) {
        this.form["id"] = item.id;
        this.form.user = (this._.has(item, 'userId')) ? item.userId : this.$auth.user().id;
        this.form["apiKey"] = item.apiKey;
        this.form["secret"] = item.secret;
        this.form["notificationActive"] = item.notificationActive;
        this.form["active"] = item.active;
        this.form.name = item.name;
        this.form["oldName"] = item.name;
        this.form.shortName = item.shortName;
        this.form.description = item.description;
        this.form.email = item.email;
      },
      resetForm() {
        this.form.user = null;
        this.form.name = null;
        this.form.shortName = null;
        this.form.description = null;
        this.form.email = null;
        this.$v.$reset();
      },
      checkAction() {
        switch (this.dialog.action) {
          case "edit":
          case "create":
            return false;
          default:
            return true;
        }
      }
    },
    computed: {
      errorsShortName() {
        let errors = [];
        if (!this.$v.form.shortName.$dirty) return errors;

        !this.$v.form.shortName.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.shortName.required")
        );

        !this.$v.form.shortName.minLength &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.shortName.length", [3], [11])
        );

        !this.$v.form.shortName.maxLength &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.shortName.length", [3], [11])
        );

        return errors;
      },
      errorsName() {
        let errors = [];
        if (!this.$v.form.name.$dirty) return errors;

        !this.$v.form.name.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.name.required")
        );

        !this.$v.form.name.minLength &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.name.length", [3], [40])
        );

        !this.$v.form.name.maxLength &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.name.length", [3], [40])
        );

        !this.$v.form.name.isUnique &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.name.isUnique")
        );

        return errors;
      },
      errorsEmail() {
        let errors = [];
        if (!this.$v.form.email.$dirty) return errors;

        !this.$v.form.email.email &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.email.email")
        );

        return errors;
      },
      errorsUser() {
        let errors = [];
        if (!this.$v.form.user.$dirty) return errors;

        !this.$v.form.user.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.application.cols.user.required")
        );

        return errors;
      }
    }
  };
</script>
